import axios from 'axios';

let globalData = null;
export const isUnCenterLink2Center = () => {
    // 1.migrationSite: true(非中台转中台)
    // 2.location.pathname: 不包含/listing-for-cms & 包含/listing
    // 3.location.search: 去除fromCms=1后还包含条件 & 不包含condition=
    if (!globalData) {
        globalData = window.sitePrepareData();
    }
    let { pathname, search } = window.location;
    search = search.slice(1).replace('fromCms=1', '');
    return (
        globalData?.migrationSite &&
        pathname.indexOf('/listing-for-cms') === -1 &&
        pathname.indexOf('/listing') > -1 &&
        search &&
        search.indexOf('condition=') === -1
    );
};

export const unCenterLink2CenterParams = params => {
    let searchParams = { ...params };
    if (isUnCenterLink2Center()) {
        delete searchParams.condition;
    }
    // console.groupCollapsed(
    //     'searchRealTimeListings unCenterLink2CenterParams:',
    //     searchParams
    // );
    // console.trace();
    // console.groupEnd();
    return searchParams;
};

export const searchRealTimeListings = params => {
    // console.groupCollapsed('searchRealTimeListings:', params);
    // console.trace();
    // console.groupEnd();
    return axios.get('/api-site/search/realTimeListings', { params });
};
